import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import BoxEditor from "./BoxEditor";
import PromotionList from "./lists/PromotionList";
import PromotionForm from "./forms/PromotionForm";
import DiscountEditor from "./DiscountEditor";
import ModalEditor from "./ModalEditor";
import Button from "../form/Button";
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import ComponentConfig from "../form/ComponentConfig";
import {sendRequest} from "../../utils/request";
import CheckBox from "../form/CheckBox";
import {isTrue} from "../../utils/other";
import ContentLoader from "../layout/ContentLoader";

class PointOfSaleType extends React.Component {

    state = {
        pointofsales: []
    }

    componentDidMount() {
        this.loadPointOfSales();
    }

    loadPointOfSales = () => {
        this.pointofsales = sendRequest({
            option: "componentlist",
            component: "PointOfSale",
            order: {field: "name", direction: "ASC"},
            itemsperpage: 0
        });
        this.pointofsales.then((response) => {
            this.setState({
                isLoading: false,
                pointofsales: response.items
            });
        });
    }

    render() {
        const all = (this.props.value || []).length + "" === "" + this.props.totalRecords && this.props.totalRecords + "" === "" + this.state.pointofsales.length;
        return (
            <Box
                theme="default"
                header="Eladási helyek"
                actions={<CheckBox
                    checked={all}
                    label="Összes"
                    disabled={this.props.loading || this.props.disabled}
                    saveChanges={() => {
                        if (!isTrue(all)) {
                            console.log(JSON.parse(JSON.stringify(this.state.pointofsales)));
                            console.log(JSON.parse(JSON.stringify(this.props.value || [])));
                            console.log(JSON.parse(JSON.stringify([...this.state.pointofsales.filter((pointofsale) => !(this.props.value || []).find((s) => s.id + "" === "" + pointofsale.id))])));
                            this.props.selectorgrid.addNewRows([...this.state.pointofsales.filter((pointofsale) => !(this.props.value || []).find((s) => s.id + "" === "" + pointofsale.id))]);
                        } else {
                            this.props.selectorgrid.onItemsRemove([...this.state.pointofsales]);
                        }
                    }}
                />}
            >
                {this.props.loading ? <ContentLoader/> : <div className="row">
                    {this.state.pointofsales.map((pointofsale, idx) => {
                        const checked = !!(this.props.value || []).find((s) => s.id + "" === "" + pointofsale.id);
                        return <div className="col-md-2 col-lg-2 col-xs-6" key={idx}><div className="form-group"><CheckBox
                            name="optional"
                            type="bool"
                            value="1"
                            label={pointofsale.name}
                            checked={checked}
                            disabled={this.props.loading || this.props.disabled}
                            saveChanges={(field, value) => {
                                if (isTrue(value)) {
                                    this.props.selectorgrid.addNewRows([pointofsale]);
                                } else {
                                    this.props.selectorgrid.onItemRemove(pointofsale);
                                }
                            }}
                        /></div></div>;
                    })}
                </div>}
            </Box>
        );
    }
}

export class PromotionEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <List
                    {...this.props}
                    theme="default"
                    header={this.props.listHeader || "Promóciók"}
                    footer={[
                        <Button key="0" type="button" color="default" disabled={this.props.isLoading} onClick={ this.pristineForm }>
                            Új
                        </Button>
                    ]}
                >
                    <PromotionList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={this.props.editorHeader || "Promóció"}
                    footer={[
                        <Button key="0"
                                type="button"
                                disabled={!this.props.dirty || this.props.isLoading}
                                color="primary"
                                className="pull-right"
                                onClick={this.saveForm}
                        >
                            Mentés
                        </Button>,
                        <Button
                            key="1"
                            disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                            color="danger"
                            className="pull-left"
                            onClick={this.props.deleteForm}
                        >
                            Törlés
                        </Button>
                    ]}
                >
                    <ComponentConfig componentName="Promotion" componentConfigAs="promotionConfig">
                        <PromotionForm {...this.props} />
                    </ComponentConfig>
                </Editor>
                {
                    this.props.values[this.props.componentConfig.idfield]
                    &&
                    <DiscountEditor
                        gridid={"promotionEditorDiscountList"}
                        presets={{promotion: this.props.values}}
                        isLoading={this.props.isLoading}
                        editor={ModalEditor}
                        selection={null}
                        listFilter={[{
                            field: "promotion",
                            value: this.props.values[this.props.componentConfig.idfield]
                        }]}
                    />
                }
                {
                    this.props.values[this.props.componentConfig.idfield]
                    &&
                    <ComponentConfig componentName="Promotion">
                        <SelectorGrid
                            columns={{
                                "name": {header: 'Megnevezés', width: 2, sortable: true, filterable: true}
                            }}
                            name={"pos"}
                            pageSize={0}
                            listfieldlabel={"name"}
                            type={PointOfSaleType}
                            data={this.props.values}
                            {...this.props.getFieldProps("pos")}
                        />
                    </ComponentConfig>
                }
            </Fragment>
        );
    }
}

export default createEditor({
    componentName: "Promotion",
    WrappedComponent: PromotionEditor,
    props: {
        type: "promotion",
        listFilter: [{
            field: "type", value: "promotion"
        }],
        componentActions: (action, data, params) => {
            data.type = "promotion";
            return {action,data,params};
        }
    }
});
